
import axios from 'axios';
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';
import { useRouterBack } from '@/composables';
import { useStore } from 'vuex';
import { AboutSection, ChangeLog } from './components';
import { ChangeLogType } from './type';

export default defineComponent({
  components: {
    AboutSection,
    ChangeLog,
  },
  setup() {
    const loading = ref(true);
    const changeLogs = ref<ChangeLogType[]>([]);
    const store = useStore();

    axios.get<ChangeLogType[]>('changeLog.json')
      .then(({ data }) => {
        // 最新排最前
        const sortedData = data.sort((a, b) => (a.date < b.date ? 1 : -1));
        changeLogs.value = sortedData;
        store.commit('setLastSawChangeLogDate', sortedData[0].date);
      })
      .catch((err) => {
        message.error('获取更新日志失败', 1.5);
        throw err;
      }).finally(() => {
        loading.value = false;
      });

    return {
      loading,
      changeLogs,
      /** 路由回退 */
      routerBack: useRouterBack(),
    };
  },
});
